import script from "./OrderCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./OrderCard.vue?vue&type=script&setup=true&lang=ts"

import "./OrderCard.vue?vue&type=style&index=0&id=7611ce5b&lang=scss"

const __exports__ = script;

export default __exports__